import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";

// ${scrolled > (target.current && target.current.offsetTop - 800) &&
// 'visible'}

const Wrapper = styled.div`
  display: flex;
  min-width: 325px;
  width: 100%;
  ${(props) =>
    props.className === "a-wrapper--right" &&
    `transition: all 300ms ease-in-out;
  transform: translate3d(300%, 0, 0);
  display: flex;
  flex-direction: column;
  align-items: center;`}
  ${(props) =>
    props.className === "a-wrapper--left" &&
    `
  transform: translate3d(-300%, 0, 0);
  transition: 300ms ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  `}
  ${(props) =>
    props.className === "a-wrapper--left" &&
    `
    opacity: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 1s;
  `}
  ${(props) =>
    props.className === "visible" &&
    ` transform: translate3d(0, 0, 0) !important;
  opacity: 1;
  margin: auto;`}
`;

const Animator = ({
  forRef,
  children,
  scrolled,
  animation,
  maxWidth,
  maxHeight,
  aliasRef,
  trigger,
}) => {
  const target = forRef ? forRef : aliasRef;

  const [className, setClassName] = useState(
    animation ? animation : "a-wrapper--right"
  );

  useEffect(() => {
    if (trigger) {
      setClassName("visible");
      setTimeout(() => {
        setClassName("");
      }, 310);
    } else {
      setClassName(animation ? animation : "a-wrapper--right");
    }
  }, [trigger]);

  return (
    <Wrapper
      ref={forRef && forRef}
      className={className}
      style={{ justifyContent: "center" }}
    >
      {children}
    </Wrapper>
  );
};

export default Animator;
